// AuthGuard Service
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';
import { NewsDetails } from 'news/models/news-details';

@Injectable()
export class NewsReadPageGuard 
{
    constructor
    (
        private auth: AuthProvider, 
        private router: Router
    ) 
    {
    }

    /**
     * CanActivate method implementation, returning true if the page can
     * be accessed or a URL tree if a redirection has to be done.
     * Will return true only if the news article is provided among the
     * query parameters
     * @param next
     * @param state
     */
    async canActivate(route: ActivatedRouteSnapshot)
    {
        let article: NewsDetails = route.queryParams.article;

        if (article)
        {
            return true;
        }
        else
        {
            let sessionToken = (await this.auth.getUserIdentity()).sessionToken;
            return this.router.parseUrl('/home/' + sessionToken);
        }
    }
}